var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckSuccess = function SvgCheckSuccess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 0C23.8014 0 30.667 6.86464 30.667 15.333C30.667 23.8014 23.8014 30.666 15.333 30.666C6.8648 30.6658 0 23.8013 0 15.333C3.54337e-07 6.86475 6.8648 0.000181789 15.333 0ZM22.2588 8.44531C21.7687 8.11858 21.1061 8.25117 20.7793 8.74121L13.5518 19.582L9.80273 15.2969C9.41477 14.8537 8.74112 14.8094 8.29785 15.1973C7.85453 15.5852 7.80935 16.2588 8.19727 16.7021L12.8643 22.0352C13.0829 22.285 13.4051 22.4191 13.7363 22.3975C14.0675 22.3758 14.3695 22.2009 14.5537 21.9248L22.5537 9.9248C22.8804 9.43472 22.7488 8.77214 22.2588 8.44531Z",
    fill: "#1D925A"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "check-success.7847b869c465f70e10e416cb0b195426.svg";